class Mask {
    constructor() {}

    get width() { throw new Error('not implemented'); }
    get height() { throw new Error('not implemented'); }

    makeGetterAtXY() {
        const width = this.width;
        const getAtPos = this.makeGetterAtPos();

        return (x, y) => {
            return getAtPos(y*width+x);
        }
    }

    makeGetterAtPos() {
        const width = this.width;
        const getAtXY = this.makeGetterAtXY();
        const floor = Math.floor;

        return (pos) => {
            return getAtXY(pos%width, floor(pos/width));
        }
    }
}

export default Mask;
